<template>
  <v-row justify="center" align="center" class="image-container pl-3 mb-2">
    <v-col class="image text-center mb-3" cols="auto" @click="uploadImage">
      <v-row class="inner" align="center" justify="center">
        <template v-if="!value"
          ><v-icon class="col add">add_a_photo</v-icon></template
        >
        <template v-else>
          <v-img
            class="col img"
            :src="imagePath"
            :contain="previewContain === 'fit'"
          ></v-img>
          <!--<div class="col img" :style="{backgroundImage: `url('${uploadsPath}/images/${value}')`}"></div>-->
        </template>
        <v-btn
          icon
          class="remove"
          small
          color="red"
          v-if="value"
          @click.stop="removeImage"
          ><v-icon>delete</v-icon></v-btn
        >
      </v-row>
    </v-col>
  </v-row>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import ImageUploadModal from './modals/ImageUploadModal.vue';
  import { ITempImage } from '../interfaces/ITempImage';
  import { Globals } from '../modules/Globals';

  @Component
  export default class SingleImageUploader extends Vue {
    @Prop() value: string;
    @Prop({ default: 1920 }) maxWidth: number;
    @Prop({ default: 1080 }) maxHeight: number;
    @Prop({ default: 'cover' }) previewContain: string;
    apiPath = Globals.apiPath;
    uploadsPath = Globals.uploadsPath;

    mounted() {}

    removeImage() {
      this.$emit('input', null);
    }

    get imagePath() {
      if (!this.value) return null;
      return `${this.uploadsPath}/${this.value}`;
    }

    uploadImage() {
      this.$modal.show(
        ImageUploadModal,
        {
          maxWidth: this.maxWidth,
          maxHeight: this.maxHeight,
        },
        {
          name: 'upload-image',
          classes: 'dialog--height-limit',
          adaptive: true,
          height: 'auto',
          scrollable: true,
          maxWidth: window.innerWidth * 0.95,
        },
        {
          save: (data: ITempImage) => {
            this.$emit('input', data.path);
          },
        }
      );
    }
  }
</script>
